import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import api from './api';
import { sesionEntrePestanas } from "./sesionEntrePestanas";

Vue.use(Vuex);

// token, claveSii y certificadoSii nunca van a PERSISTIDO_EN_LOCAL. rehydrated pasa a booleano el certificado de un blob
// anterior, que trae su clave. Ver claude.md, sección 20.
const PERSISTIDO_EN_SESION = [
  "user", "token", "expireTime", "menu", "transferencias", "businesSelected", "businessLink",
  "siiConfigurations", "estadoCertificado", "miperfil", "miperfil_completo", "perfil_inv_actualizado",
  "cdiAlertShown"
];

const PERSISTIDO_EN_LOCAL = [
  "onlyActives", "gatewayTransaction", "gatewayTransactionConfirmed", "transactionIsPendingPayment",
  "transactionProjectId", "pendingPaymentsIds", "lastCod", "proyectId", "currentInvestmentId",
  "isLastInvestment", "lastSimulation", "business", "requesting", "amountFinanced", "amountPymes",
  "amountRenta", "amountFacturas", "amountInveriones", "questionId", "routes", "ip", "token_ip",
  "showPanelInv", "openMenuPanel", "conf_inv"
];

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: PERSISTIDO_EN_LOCAL,
      rehydrated: (store: any) => store.commit("setcertificadoSii", store.state.certificadoSii)
    }),
    createPersistedState({ key: "vuex-sesion", storage: window.sessionStorage, paths: PERSISTIDO_EN_SESION }),
    sesionEntrePestanas
  ],
  state: {
    menu:null,
    user: null,
    token: null,
    expireTime: null,
    gatewayTransaction: null,
    lastCod: null,
    onlyActives: true,
    gatewayTransactionConfirmed: false,
    transactionIsPendingPayment: false,
    pendingPaymentsIds: [],
    transactionProjectId: null,
    business: null,
    requesting: null,
    proyectId: null,
    currentInvestmentId: null,
    isLastInvestment: false,
    lastSimulation: null,
    amountFinanced: null,
    amountPymes: null,
    amountRenta: null,
    amountFacturas: null,
    amountInveriones: null,
    questionId: null,
    routes: null,
    ip:null,
    transferencias:null,
    businesSelected:null,
    businessLink:null,
    showPanelInv:null,
    siiConfigurations:null,
    claveSii:null,
    certificadoSii:false,
    estadoCertificado:null, //"VIGENTE", "POR EXPIRAR", "EXPIRADO"
    openMenuPanel: false,
    miperfil:null,
    miperfil_completo:null,
    token_ip: null,
    perfil_inv_actualizado: null,
    conf_inv: {
      state: true,
      message: null
    },
    cdiAlertShown: false

  },
  mutations: {
    setQuestionId(state, id) {
      state.questionId = id;
    },
    clearQuestionId(state) {
      state.questionId = null;
    },
    hideOrNot(state, newState) {
      state.onlyActives = newState;
    },
    setCurrentInvestment(state, { investmentId, isLastInvestment, proyectId }) {
      state.currentInvestmentId = investmentId;
      state.isLastInvestment = isLastInvestment;
      state.proyectId = proyectId;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setBusiness(state, business) {
      state.business = business;
    },
    setRequesting(state, request) {
      state.requesting = request
    },
      setEmpresasCount(state, count) {
      // @ts-ignore
      state.user.empresas_count = count;
    },
    setExpireTime(state, expireTime) {
      state.expireTime = expireTime;
    },
    deleteSimulation(state) {
      state.lastSimulation = null;
    },
    logout(state) {
      // Se limpia aquí y no en el .then: vuex-persistedstate solo guarda tras una mutación, y si no vuex-sesion puede
      // quedar con el token. api.logout() ya armó el header. Ver claude.md, sección 20.
      api.logout().catch(() => {});
      state.user = null;
      state.token = null;
      state.expireTime = null;
      state.lastSimulation = null;
      state.menu = null;
      state.miperfil = null;
      state.miperfil_completo = null;
      state.perfil_inv_actualizado = null;
      state.cdiAlertShown = false;
    },
    setCdiAlertShown(state) {
      state.cdiAlertShown = true;
    },
    logAndReconnect(state) {
      state.user = null;
      state.expireTime = null;
      state.lastSimulation = null;
    },
    setGatewayTransaction(state, transaction) {
      state.gatewayTransaction = transaction;
      state.gatewayTransactionConfirmed = false;
      state.transactionIsPendingPayment = false;
    },
    resetGatewayTransactionConfirmation(state) {
      state.gatewayTransactionConfirmed = false;
    },
    setLastCod(state, cod) {
      state.lastCod = cod;
    },
    confirmGatewayTransaction(state) {
      state.gatewayTransactionConfirmed = true;
    },
    setTransactionPendingPayment(state) {
      state.transactionIsPendingPayment = true;
    },
    setTransactionPaymentType(state, id) {
      // @ts-ignore
      state.gatewayTransaction.pago_deta_tipo_id = id;
    },
    setPendingPaymentsIds(state, ids) {
      state.pendingPaymentsIds = ids;
    },
    setTransactionProjectId(state, id) {
      state.transactionProjectId = id;
    },
    setLastSimulation(state, simulation) {
      state.lastSimulation = simulation;
    },
    setAmountFinanced(state, amountFinanced) {
      state.amountFinanced = amountFinanced;
    },
    setAmountDataHome(state, dataHome){
      state.amountFinanced = dataHome.amountFinanced;
      if(dataHome.amountPymes)
        state.amountPymes = dataHome.amountPymes;
      if(dataHome.amountRenta)
        state.amountRenta = dataHome.amountRenta;
    },
    setAmountDataHomeProntoPago(state, dataHome){
      state.amountFinanced = dataHome.amountFinanced;
      if(dataHome.amountFacturas)
        state.amountFacturas = dataHome.amountFacturas;
      if(dataHome.amountInveriones)
        state.amountInveriones = dataHome.amountInveriones;
    },
    setRoutes(state, route) {
      state.routes = route;
    },
    setIp(state,payload){
      state.ip = payload
    },

    setTransferencias(state,payload){
      state.transferencias = payload
    },
    setMenu(state,payload){
      state.menu = payload
    },
    setBusinessSelected(state,payload){
      state.businesSelected = payload
    },
    setBusinessLink(state,payload){
      state.businessLink = payload
    },
    setShowPanelInv(state,payload){
      state.showPanelInv = payload
    },
    setsiiConfigurations(state,payload){
      state.siiConfigurations = payload
    },
    setclaveSii(state,payload){
      state.claveSii = payload
    },
    setcertificadoSii(state,payload){
      state.certificadoSii = !!payload
    },
    setEstadoCertificadoSii(state, payload){
      state.estadoCertificado = payload;
    },
    setOpenMenuPanel(state, estado){
      state.openMenuPanel = estado;
    },
    setmiperfil(state,payload){
      state.miperfil = payload
    },
    setMiPerfilCompletoInversionista(state,payload){
      state.miperfil_completo = payload;
    },
    setTokenIP(state, token) {
      state.token_ip = token;
    },
    setPerfilInvActualizado(state, payload){
      state.perfil_inv_actualizado = payload; 
    },
    setConfInv(state, payload) {
      state.conf_inv.state = payload.state;
      state.conf_inv.message = payload.message;
    }
  },
  getters: {
    canShowPendingPayments: state => (ids: Array<number>) => {
      return false;
      // @ts-ignore
      // return !(ids.map((id: number) => state.pendingPaymentsIds.includes(id)).every((val) => val == true) && ids.length == state.pendingPaymentsIds.length)
    },
    canBuyTokens: state => () => {
      //@ts-ignore
      return state.user !== null ? true : false;
    },
    canInvest: state => () => {
      //@ts-ignore
      return state.user.invFormCompleto ? true : false;
    }, 
    cdiVigente: state => () => {
      //@ts-ignore
      return state.user ? !state.user.cdi_vencido_front_site : false;
    }
  },
  actions: {}
});
